import React, { useState, useEffect } from "react";

const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const adminInfo = localStorage.getItem("adminUser");

    if (adminInfo) {
      setIsAuthenticated(true);
    }

    setLoading(false);
  }, []);

  if (loading) return null;

  return (
    <React.Fragment>
      {React.cloneElement(children, {
        isAuthenticated,
      })}
    </React.Fragment>
  );
};

export default AuthProvider;
